<div [ngClass]="styles.aspectWrap" [vbWatchDimensions]="[aspectInner]">
	<div #aspectInner [ngClass]="styles.aspectInner">
		<div #innerContent [ngClass]="styles.innerContent" vbImageLoad [bgImageUri]="bgUrl">
			<video-preview-player-tile *ngIf="layoutCfg.backgroundVideo" [cfg]="layoutCfg.backgroundVideo" [presenter]="getPresenter(layoutCfg.backgroundVideo.userId)" [isPreview]="false" [isProducer]="isProducer">
			</video-preview-player-tile>
			<ng-container *ngFor="let cfg of layoutCfg.videos; index as index; trackBy: identity">
				<video-preview-player-tile vbDroppable [dropEnabled]="canEdit && isPreview" (drop)="drop($event, index)" [label]="(index + 1) | number" [cfg]="cfg" [presenter]="getPresenter(cfg.userId)" [isPreview]="isPreview" [index]="index" [isProducer]="isProducer">
				</video-preview-player-tile>
			</ng-container>

			<ng-container *ngIf="isProducer && layoutCfg.videos.length === 0">
				<div [ngClass]="styles.noStreamText" vbDroppable [dropEnabled]="canEdit" (drop)="dropInitialVideo($event)">
					{{ noStreamText | translate }}
				</div>
			</ng-container>
		</div>
		<ng-content></ng-content>
	</div>
</div>
